import request from '../common/request.js';

//获取设备列表
export function GetSettingsList(payload) {
    return request.post('/sys/GetSettingsList', payload);
}

//添加配置项
export function AddSetting(payload) {
    return request.post('/sys/AddSetting', payload);
}

//更新配置项
export function UpdateSetting(payload) {
    return request.post('/sys/UpdateSetting', payload);
}

//删除配置项
export function DeleteSetting(payload) {
    return request.post('/sys/DeleteSetting', payload);
}